import React from 'react'
import { BiCalendarCheck, BiCalendarHeart, BiCalendarX, BiChevronRight } from 'react-icons/bi'
import { Alerts, CompInfo, InputButton, Loading, TLPedido } from '../../Simple'
import { IoChevronBackOutline } from 'react-icons/io5'
import { AgendamentoContext } from '../../../contexts/AgendamentoContext'
import { IoMdChatbubbles } from 'react-icons/io'
import { CancelarPedido, HistoricoAgendamento } from '../../Modais'
import { ChatContext } from '../../../contexts/ChatContext'
import { LocalStorage, Services } from '../../../services'
import { CompError } from '../../Complex'
import { CalClock } from '../../../assets/'
import { Button, Typography, useTheme } from '@mui/material'
import RouterHook from '../../../contexts/RouterHook'
import { Box } from '@mui/system'
import moment from 'moment'
import { TbEdit } from 'react-icons/tb'

import './stylesDA.css'
import { BsStarFill } from 'react-icons/bs'
import { EmpresasContext } from '../../../contexts/EmpresasContext'
import useDetalhesAgendamento from './DetalhesAgendamento.functions'
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded'
import { ToastMessages } from '../../ToastMessages'

export default function DesktopAgendamento() {
  const serverRouter = RouterHook()
  const { sttChatCtx, actionsChatCtx } = React.useContext(ChatContext)
  const {
    verificarAcessoUsuario,
    buscarPedido,
    isLimiteReagendamentoExcedido,
    checarRegraCancelamento,
    semAcesso,
  } = useDetalhesAgendamento()
  const { sttCtxAgend, loadAgend, actionsAgend, modaisAgend } = React.useContext(AgendamentoContext)
  const { actionsCtxEmps, BuscarQuadrasEmpresa } = React.useContext(EmpresasContext)
  //console.log('Pedido!!!', sttCtxAgend.pedido)
  const theme = useTheme()
  const color = {
    Solicitado: '#ff7043',
    Reservado: '#24ad49',
    Realizado: '#00cda4',
    Cancelado: '#bf3324',
    Avaliado: '#FFD700',
    Ofuscado: '#adadad',
  }
  //console.log('Pedido!!!', sttCtxAgend)
  React.useEffect(() => {
    const location = window.location.pathname.split('/')
    const idpedido = location[location.length - 1]
    buscarPedido(idpedido).then(pedido => {
      verificarAcessoUsuario(pedido)
    })
  }, [])

  const pagamentoLocal =
    sttCtxAgend.pedido.formaPagamento === 'DINHEIRO' ||
    sttCtxAgend.pedido.formaPagamento === 'LOCAL' ||
    sttCtxAgend.pedido.formaPagamento === 'MAQUINA_CARTAO'

  const reagendavel =
    (sttCtxAgend.pedido.status === 'AGENDADO' || sttCtxAgend.pedido.status === 'SOLICITADO') &&
    !(sttCtxAgend.pedido.status === 'SOLICITADO' && sttCtxAgend.pedido.formaPagamento === 'PIX')

  function AbrirChatPedido() {
    if (sttChatCtx.modeChat !== 'agendamentos') actionsChatCtx.handleModeChat('agendamentos')
    LocalStorage.set('chat-selected', { mode: 'agendamentos', id: sttCtxAgend.pedido.chat_idchat })
    serverRouter('chat', sttCtxAgend.pedido.usuario_idusuario)
  }

  function ReturnSttPage() {
    if (modaisAgend.cancelamento) {
      actionsAgend.handleModaisAgend('cancelamento', false)
    } else {
      serverRouter('back')
    }
  }

  function handleReagendar() {
    if (isLimiteReagendamentoExcedido()) ToastMessages.userRescheduleLimit()
    else if (!checarRegraCancelamento()) ToastMessages.rescheduleTimeExpired()
    else
      Alerts.question(
        'Deseja reagendar este horário?',
        sttCtxAgend.pedido.status === 'AGENDADO' &&
          pagamentoLocal &&
          !sttCtxAgend.pedido.mensalista_idmensalista
          ? 'O novo horário precisará ser aprovado pelo gestor da quadra.'
          : 'Você conseguirá reagendar até 2 vezes, dentro de no máximo 30 dias.',
        () => {
          Reagendar()
        },
      )
  }

  function AbrirModalHistorico() {
    actionsAgend.handleModaisAgend('historicoAgendamento', true)
  }

  async function Reagendar() {
    actionsAgend.ReagendarAgendamento()
    actionsCtxEmps.SelectEmpresa(sttCtxAgend.pedido.empresa)
    const { quadras } = await BuscarQuadrasEmpresa(sttCtxAgend.pedido.empresa.idempresa)
    actionsCtxEmps.handleSttPg('selectedDay', moment(sttCtxAgend.pedido.dataInicio))
    actionsCtxEmps.handleSttPg('empresa', { ...sttCtxAgend.pedido.empresa, quadras })
    serverRouter('centro-esportivo', sttCtxAgend.pedido.empresa.username)
  }

  //console.log('Pedido!!!', sttCtxAgend.pedido)
  React.useEffect(() => {
    window.history.pushState(null, null, window.location.pathname)
    window.addEventListener('popstate', ReturnSttPage)
    return () => {
      window.removeEventListener('popstate', ReturnSttPage)
    }
  }, [modaisAgend])

  return (
    <>
      {modaisAgend.cancelamento && (
        <CancelarPedido
          modal={modaisAgend.cancelamento}
          pedido={sttCtxAgend.pedido}
          ClosedModal={() => {
            actionsAgend.handleModaisAgend('cancelamento', false)
          }}
        />
      )}
      {modaisAgend.historicoAgendamento && <HistoricoAgendamento pedido={sttCtxAgend.pedido} />}
      {loadAgend.page ? (
        <div className='contain-loading'>
          <Loading text={'Carregando...'} color={'white'} />
        </div>
      ) : semAcesso ? (
        <CompError
          title={'Agendamento não encontrado'}
          message={'O agendamento que você está tentando acessar não foi encontrado.'}
        />
      ) : (
        <Box className='contain-page-agendamento'>
          {/* Botão de voltar na tela */}
          <IoChevronBackOutline
            size={30}
            className='icon-back-left'
            onClick={() => {
              ReturnSttPage()
            }}
          />
          {/* Div superior */}
          <div className='contain-detalhes-pedido-topo tw-p-2'>
            {/* Componente esquerdo da div superior */}

            {ReturnFalta(sttCtxAgend.pedido)}
            {/* Componente central da div superior */}
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                <div
                  className={
                    reagendavel
                      ? 'contain-detalhes-pedido-topo-central-reagendavel'
                      : 'contain-detalhes-pedido-topo-central'
                  }
                >
                  <h2>{`${Services.ReturnHoraMin(new Date(sttCtxAgend.pedido.dataInicio))} às ${Services.ReturnHoraMin(
                    new Date(sttCtxAgend.pedido.dataFinal),
                  )}`}</h2>

                  <h3>
                    {Services.DataFormat('dia,DD/MM/YY', sttCtxAgend.pedido.dataInicio, null)}
                  </h3>
                  {sttCtxAgend.pedido.mensalista_idmensalista !== null && (
                    <Button
                      variant='text'
                      onClick={() => {
                        serverRouter('mensalista', sttCtxAgend.pedido.mensalista_idmensalista)
                      }}
                    >
                      HORÁRIO FIXO
                      <BiChevronRight size={20} />
                    </Button>
                  )}
                </div>
                {reagendavel && (
                  <Button
                    onClick={handleReagendar}
                    sx={{
                      p: 0,
                      display: 'flex',
                      minWidth: '30px',
                      borderBottomLeftRadius: '0px',
                      borderTopLeftRadius: '0px',
                      borderBottomRightRadius: '7px',
                      borderTopRightRadius: '7px',
                      backgroundColor: theme.palette.primary.main,
                      '&:hover': {
                        backgroundColor: theme.palette.primary.dark,
                      },
                    }}
                  >
                    <TbEdit size={20} color='white' />
                  </Button>
                )}
              </Box>
              {returnHistoricoAgendamentoButton()}
            </Box>
            {/* Componente direito da div superior */}
            <div>
              {(sttCtxAgend.pedido.status === 'SOLICITADO' &&
                sttCtxAgend.pedido.formaPagamento !== 'PIX') ||
              sttCtxAgend.pedido.status === 'AGENDADO' ? (
                <>
                  <Button
                    variant='text'
                    fullWidth
                    color='error'
                    onClick={() => {
                      actionsAgend.handleModaisAgend('cancelamento', true)
                    }}
                  >
                    CANCELAR
                  </Button>
                </>
              ) : (
                <></>
              )}
              <h2 className='numero-pedido-label'>Nº #{sttCtxAgend.pedido.idpedido}</h2>
            </div>
          </div>
          {/* Time Line do status do componente */}
          <TLPedido pedido={sttCtxAgend.pedido} />

          {/* Div com 3 componentes de informação Pagamento , Avaliação , Local */}
          <div
            className='contain-componentes-informacao'
            style={
              sttCtxAgend.pedido.status === 'CANCELADO' &&
              sttCtxAgend.pedido.motivoCancelamento !== null
                ? { marginTop: '10px' }
                : {}
            }
          >
            {/* Componente de pagamento */}
            <CompInfo mode={1} pedido={sttCtxAgend.pedido} />
            {/* Componente de avaliação */}
            {sttCtxAgend.pedidoStt.pedidoRealizado && (
              <div className='componente-de-informacao'>
                <h2>AVALIAÇÃO</h2>
                <div className='componente-de-informacao-line'>
                  <p>
                    {sttCtxAgend.pedido.avaliacao === null
                      ? `Como você avalia seu agendamento?`
                      : ``}
                  </p>
                </div>
                <div className='componente-de-informacao-estrelas'>
                  {[1, 2, 3, 4, 5].map(index => {
                    return (
                      <BsStarFill
                        key={index}
                        size={25}
                        color={
                          sttCtxAgend.pedido.avaliacao === null
                            ? color.Ofuscado
                            : index <= sttCtxAgend.pedido.avaliacao
                              ? color.Avaliado
                              : color.Ofuscado
                        }
                        style={{ marginRight: 5 }}
                      />
                    )
                  })}
                </div>
                <button
                  className='btt-avaliar-pedido'
                  onClick={() => {
                    if (!sttCtxAgend.pedidoStt.pedidoAvaliado) {
                      if (sttCtxAgend.pedidoStt.pedidoRealizado) {
                        actionsAgend.handleModaisAgend('avaliacao', true)
                      } else {
                        Alerts.swal(
                          'warning',
                          'Atenção',
                          'A avaliação só pode ser feita após a realização do agendamento.',
                        )
                      }
                    }
                  }}
                >
                  {sttCtxAgend.pedidoStt.pedidoAvaliado ? 'Ver avaliação completa' : 'AVALIAR'}
                </button>
              </div>
            )}
            {/* Componente de local */}
            <CompInfo mode={3} pedido={sttCtxAgend.pedido} />
          </div>
          {sttCtxAgend.pedido.observacoes !== null && sttCtxAgend.pedido.observacoes !== '' ? (
            <div
              className='componente-de-observacao'
              style={sttCtxAgend.pedidoStt.pedidoRealizado ? { width: '99%' } : { width: '66.66%' }}
            >
              <h2>OBSERVAÇÃO</h2>
              <h3>{sttCtxAgend.pedido.observacoes}</h3>
            </div>
          ) : (
            <></>
          )}
          <div className='contain-inferior-btts'>
            <InputButton
              variant='contained'
              fullWidth={false}
              sx={{
                width: '100%',
                maxWidth: '200px',
                margin: '10px 0 0 0',
                bgcolor: '#4d87fa',
                '&:hover': { bgcolor: '#4e72ff' },
              }}
              startIcon={<IoMdChatbubbles size={20} style={{ marginRight: 10, marginLeft: 10 }} />}
              onClick={() => {
                AbrirChatPedido()
              }}
            >
              ABRIR CHAT
            </InputButton>
            {reagendavel && (
              <InputButton
                sx={{ width: '100%', maxWidth: '200px', margin: '10px 0 0 0' }}
                startIcon={<TbEdit size={20} style={{ marginRight: 10, marginLeft: 10 }} />}
                onClick={() => {
                  handleReagendar()
                }}
              >
                REAGENDAR
              </InputButton>
            )}
          </div>
        </Box>
      )}
      <Box sx={{ height: '100%', display: 'flex', alignItems: 'center', pb: 1 }}>
        <div
          className='rtz-banner'
          data-rtz-espaco-id='118'
          style={{ width: '728px', height: '90px', overflow: 'hidden' }}
          data-rtz-width='728'
          data-rtz-height='90'
          title='Espaço publicitário'
          data-rtz-display-formato='imagem_video'
          data-rtz-tipo-criativo='360'
          data-rtz-device='desktop'
        ></div>
      </Box>
    </>
  )

  function returnHistoricoAgendamentoButton() {
    return (
      <Button
        variant='text'
        onClick={AbrirModalHistorico}
        sx={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Typography variant='body2'>Histórico do agendamento</Typography>
        <ChevronRightRoundedIcon />
      </Button>
    )
  }

  function ReturnFalta(pedido) {
    let falta = moment(pedido.dataInicio).startOf('minute').fromNow().toUpperCase()
    switch (pedido.status) {
      case 'SOLICITADO':
        return (
          <div className='contain-detalhes-falta-pedido-collum'>
            <div className='contain-detalhes-falta-pedido-row'>
              <img
                src={CalClock}
                alt='clock'
                color={'#ff7043'}
                style={{ color: '#ff7043', width: '25px', height: '25px' }}
              />
              <h3 style={{ color: '#ff7043' }}>{pedido.status}</h3>
            </div>
            <h3 className={'text-states-detalhes-pedido'}>{falta}</h3>
          </div>
        )
      case 'AGENDADO':
        return (
          <div className='contain-detalhes-falta-pedido-collum'>
            <div className='contain-detalhes-falta-pedido-row'>
              <BiCalendarHeart size={25} color={'#24ad49'} />
              <h3 style={{ color: '#24ad49' }}>{pedido.status}</h3>
            </div>
            <h3 className={'text-states-detalhes-pedido'}>{falta}</h3>
          </div>
        )
      case 'CANCELADO':
        return (
          <div className='contain-detalhes-falta-pedido-collum'>
            <div className='contain-detalhes-falta-pedido-row'>
              <BiCalendarX size={25} color={'#bf3324'} />
              <h3 style={{ color: '#bf3324' }}>{pedido.status}</h3>
            </div>
            {/*<h3
              className = {"text-states-detalhes-pedido"}
              >
              {falta}
              </h3>*/}
          </div>
        )
      case 'REALIZADO':
        falta = moment(pedido.dataFinal).startOf('minute').fromNow().toUpperCase()
        return (
          <div className='contain-detalhes-falta-pedido-collum'>
            <div className='contain-detalhes-falta-pedido-row'>
              <BiCalendarCheck size={25} color={'#00cda4'} />
              <h3 style={{ color: '#00cda4' }}>{pedido.status}</h3>
            </div>
            <h3 className={'text-states-detalhes-pedido'}>{falta}</h3>
          </div>
        )
    }
  }
}
